import React from "react";
import {
  Cpu,
  Users,
  ChartNoAxesCombined,
  Infinity as InfinityIcon,
  ArrowRight,
} from "lucide-react";

import "./FutureSection.css";

const futureFeatures = [
  {
    icon: Cpu,
    title: "Advanced Technologies",
    text: "Work on next-generation semiconductor solutions",
  },
  {
    icon: Users,
    title: "Experienced Professionals",
    text: "Learn and collaborate with industry experts",
  },
  {
    icon: ChartNoAxesCombined,
    title: "Meaningful Programs",
    text: "Contribute to impactful engineering projects",
  },
  {
    icon: InfinityIcon,
    title: "Long-Term Growth",
    text: "Build a rewarding career with Digicomm",
  },
];

const FutureSection: React.FC = () => {
  const handleApply = () => {
    const jobsSection = document.getElementById("open-positions");

    if (jobsSection) {
      jobsSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <section className="future-section">
      {/* Background */}
      <div className="future-bg-grid" />
      <div className="future-blue-glow" />
      <div className="future-gold-glow" />

      {/* RIGHT ENGINEERING IMAGE */}
      <div className="future-engineer-visual">
        <div className="future-engineer-image" />
        <div className="future-engineer-overlay" />

        <div className="future-top-message">
          <span>INNOVATION</span>
          <span>THROUGH</span>
          <span>PEOPLE</span>
          <i />
        </div>

        <div className="future-bottom-message">
          <span>ENGINEERS</span>
          <span>POWER</span>
          <span>POSSIBILITIES</span>
          <i />
        </div>
      </div>

      {/* DIAGONAL GOLD DIVIDER */}
      <div className="future-diagonal-line" />

      <div className="future-container">
        {/* ====================================================
            TOP CONTENT
        ==================================================== */}

        <div className="future-main">
          <div className="future-copy">
            <div className="future-eyebrow">
              <span />
              BUILD THE FUTURE WITH US
            </div>

            <h2 className="future-title">
              Build the Future of
              <br />
              <strong>Semiconductor Engineering</strong>{" "}
              <span>with Us</span>
            </h2>

            <p className="future-description">
              The future of semiconductor innovation will be shaped by
              engineers who are curious, collaborative, and committed to
              solving complex challenges. At Digicomm Semiconductor, you'll
              have the opportunity to work alongside experienced
              professionals, contribute to meaningful engineering programs,
              and continue growing throughout your career.
            </p>

            <p className="future-description future-description-small">
              If you're passionate about engineering excellence and ready to
              make an impact across the semiconductor development lifecycle,
              we'd love to hear from you.
            </p>

            <div className="future-actions">
              <button
                type="button"
                className="future-apply-button"
                onClick={handleApply}
              >
                <span>Apply Now</span>

                <ArrowRight
                  className="future-arrow"
                  size={27}
                  strokeWidth={1.7}
                />
              </button>

              <div className="future-tagline">
                <span className="future-tagline-line" />

                <p>
                  IDEAS TODAY.
                  <br />
                  A SMARTER TOMORROW.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ====================================================
            FEATURES
        ==================================================== */}

        <div className="future-features">
          {futureFeatures.map((feature) => {
            const Icon = feature.icon;

            return (
              <article className="future-feature" key={feature.title}>
                <div className="future-feature-icon">
                  <Icon size={31} strokeWidth={1.7} />
                </div>

                <div className="future-feature-content">
                  <h3>{feature.title}</h3>

                  <p>{feature.text}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FutureSection;